import { render, staticRenderFns } from "./Bubble5.vue?vue&type=template&id=c4d3b194"
import script from "./Bubble5.vue?vue&type=script&lang=js"
export * from "./Bubble5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports